module.exports = __webpack_public_path__ + "img/riwayat_gaji.a924615c.png";